import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import TrimbleMaps from '@trimblemaps/trimblemaps-js';

@Injectable({
  providedIn: 'root',
})
export class LocationMarkerService {
  markerAddSource = new Subject<Record<string, any>>();
  stopButtonSource = new Subject<boolean>();
  stopAddSource = new Subject<Record<string, any>>();
  markerAdd$ = this.markerAddSource.asObservable();
  stopButton$ = this.stopButtonSource.asObservable();
  stopAdd$ = this.stopAddSource.asObservable();

  addMarker(lngLat: TrimbleMaps.LngLat): void {
    this.markerAddSource.next(lngLat);
  }

  hasStopButton(hasButton: boolean): void {
    this.stopButtonSource.next(hasButton);
  }

  addStopToRoute(lngLat: TrimbleMaps.LngLat): void {
    this.stopAddSource.next(lngLat);
  }
}
